
import React from 'react';
import { useQuickscan } from '@/contexts/QuickscanContext';
import { useSwipeNavigation } from '@/hooks/useSwipeNavigation';
import { WelcomeScreen } from './screens/WelcomeScreen';
import { BusinessTypeScreen } from './screens/BusinessTypeScreen';
import { EnergyCostScreen } from './screens/EnergyCostScreen';
import { EnergyPeakScreen } from './screens/EnergyPeakScreen';
import { CurrentSolutionsScreen } from './screens/CurrentSolutionsScreen';
import { ExpansionPlansScreen } from './screens/ExpansionPlansScreen';
import { PrioritiesScreen } from './screens/PrioritiesScreen';
import { ResultsScreen } from './screens/ResultsScreen';
import { ProgressIndicator } from './ProgressIndicator';

const screens = [
  WelcomeScreen,
  BusinessTypeScreen,
  EnergyCostScreen,
  EnergyPeakScreen,
  CurrentSolutionsScreen,
  ExpansionPlansScreen,
  PrioritiesScreen,
  ResultsScreen
];

export const QuickscanFlow = () => {
  const { currentStep, nextStep, prevStep } = useQuickscan();
  const CurrentScreen = screens[currentStep];

  // Add swipe navigation for mobile
  const swipeRef = useSwipeNavigation({
    onSwipeLeft: () => {
      if (currentStep < screens.length - 1) {
        nextStep();
      }
    },
    onSwipeRight: () => {
      if (currentStep > 0) {
        prevStep();
      }
    },
    threshold: 100
  });

  return (
    <div ref={swipeRef} className="container mx-auto px-4 py-8 max-w-4xl touch-pan-y">
      {currentStep > 0 && currentStep < 7 && <ProgressIndicator />}
      <div className="animate-slide-up">
        <CurrentScreen />
      </div>
      
      {/* Mobile swipe hint */}
      {currentStep > 0 && currentStep < 7 && (
        <div className="md:hidden mt-8 text-center text-sm text-gray-500">
          Swipe om te navigeren ← →
        </div>
      )}
    </div>
  );
};
